import React from 'react';
import { Switch } from 'react-router-dom';
import { AjaxSpinner } from '@utahdts/dts-react-common';
import AjaxSpinnerBackdrop from '@utahdts/dts-react-common/components/ajax-spinner/AjaxSpinnerBackdrop';
import { observer } from 'mobx-react';
import Pages, { renderPageRoutes } from '../Pages';
import appStore from '../../mobx/appStore';
import { useFirebaseAuth } from '../../auth/FirebaseAuthProvider';
import UtahIdLogin from '../../auth/UtahIdLogin';

/**
 * Route guard. Auth is provided by Firebase (id.utah.gov OIDC). Gating order:
 *  - until the initial auth state is known: full-page spinner
 *  - no Firebase user: public sign-in screen (UtahIdLogin)
 *  - Firebase user present but backend profile still loading: spinner
 *  - fully authenticated: the application routes
 */
const ProtectedRoutes = () => {
  const { currentUser, ready } = useFirebaseAuth();

  if (!ready) {
    return (
      <AjaxSpinner backdropType={AjaxSpinnerBackdrop.COVER_PAGE} size={100} />
    );
  }

  if (!currentUser) {
    return <UtahIdLogin />;
  }

  if (!appStore.loggedInUser) {
    return (
      <AjaxSpinner backdropType={AjaxSpinnerBackdrop.COVER_PAGE} size={100} />
    );
  }

  return <Switch>{renderPageRoutes(Pages)}</Switch>;
};

export default observer(ProtectedRoutes);
